import React from 'react'

export default function Confirmation(props) {
  return (
      <h1>{props.message}</h1>
  )
}